<app-card>
  <span class="header">Rental Details</span>
  <div class="col">
    <div class="form-row">
      <div class="form-group form-group-inline col-6">
        <label>Daily Rental Price</label>
        <input
          [disabled]="disabled"
          id="tool-search-input"
          type="text"
          class="form-control"
          placeholder="Enter daily rate"
          [(ngModel)]="formattedValue['rentalPriceDaily']"
          name="rentalPriceDaily"
          (blur)="formatToCurrency('rentalPriceDaily', $event)" />
      </div>
      <div class="form-group form-group-inline col-6">
        <label>Weekly Rental Price</label>
        <input
          [disabled]="disabled"
          id="tool-search-input"
          type="text"
          class="form-control"
          placeholder="Enter weekly rate"
          [(ngModel)]="formattedValue['rentalPriceWeekly']"
          name="rentalPriceWeekly"
          (blur)="formatToCurrency('rentalPriceWeekly', $event)" />
      </div>
      <div class="form-group form-group-inline col-6">
        <label>Monthly Rental Price</label>
        <input
          [disabled]="disabled"
          id="tool-search-input"
          type="text"
          class="form-control"
          placeholder="Enter monthly rate"
          [(ngModel)]="formattedValue['rentalPriceMonthly']"
          name="rentalPriceMonthly"
          (blur)="formatToCurrency('rentalPriceMonthly', $event)" />
      </div>
    </div>
  </div>
</app-card>
